<template>
  <div>
    <PageHeader :headerTitle="headerTitle" />
    <div v-if="truck" class="truck-view-container">
      <div class="truck-view-content">
        <div class="gallery-container">
          <div ref="imageSlidesBlock" class="gallery">
            <template v-if="truck.pics.length">
              <ImageBlock
                v-for="(pic, index) in truck.pics"
                :key="pic"
                :imgConfig="{
                  clientID: truck.dealerid,
                  picName: pic,
                  unitID: truck._id,
                  alt:
                    index == 0
                      ? imgAlt
                      : `${imgAlt} (${index + 1} / ${truck.pics.length})`
                }"
                :showTextHint="false"
              />
            </template>
            <template v-else>
              <ImageBlock :showTextHint="false" />
            </template>
          </div>
          <div v-if="truck.pics.length > 1" class="slide-buttons">
            <button class="pre-slide-btn" @click="slideImage(-1)"></button>
            <span>{{ picIndexIndicator }}</span>
            <button class="next-slide-btn" @click="slideImage(1)"></button>
          </div>
        </div>
        <div class="truck-info">
          <TruckInfo
            :truckInfo="truck"
            :secondValue="secondValue"
            :fifthValue="fifthValue"
            :fromAggregate="false"
          />
          <div v-if="truck.stocknumber" class="stock-number">
            Stock Number: <span>{{ truck.stocknumber }}</span>
          </div>
          <a
            class="call-dealer-btn btn-basic"
            :href="`tel:${truck.dealerphone}`"
            @click="
              sendLeadRequests([
                {
                  functionName: 'sendTruckLead',
                  lead: { leadType: truckLeadTypes.call }
                }
              ])
            "
          >
            {{ vw > 420 ? truck.dealerphone : 'CALL THIS DEALER' }}
          </a>
          <button class="emailed-dealer-btn btn-basic" v-if="emailed">
            EMAIL HAS BEEN SENT
          </button>
          <button
            class="email-dealer-btn btn-basic"
            @click="displayCertainPopup()"
            v-else
          >
            EMAIL THIS DEALER
          </button>
          <button class="emailed-dealer-btn btn-basic" v-if="emailed">
            OFFER HAS BEEN SENT
          </button>
          <button
            class="offer-btn btn-basic"
            @click="displayCertainPopup(true)"
            v-else
          >
            MAKE AN OFFER
          </button>
          <table class="truck-description-table">
            <tr>
              <th>Category</th>
              <td>{{ truck.category }}</td>
            </tr>
            <tr v-if="truck.vin">
              <th>VIN</th>
              <td>{{ truck.vin }}</td>
            </tr>
            <tr v-if="truck.transmission">
              <th>Transmission</th>
              <td>{{ truck.transmission }}</td>
            </tr>
            <tr v-if="truck.color">
              <th>Color</th>
              <td>{{ truck.color }}</td>
            </tr>
            <tr v-if="description">
              <th>Description</th>
              <td>
                <div class="description-data">{{ description }}</div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="view-units-btns">
        <router-link
          class="view-dealer-inventory btn-basic"
          :to="`/trucks-by-dealer/${truck.dealerid}`"
        >
          VIEW DEALER UNITS
        </router-link>
        <router-link
          :to="similarUnitsRoute"
          class="view-similar-units btn-basic"
        >
          VIEW SIMILAR UNITS
        </router-link>
      </div>
      <!-- <PartnerAd
        :partnerAdConfig="{
          partner: 'eCapital',
          filePath: 'factoring',
          adType: 'freight factoring'
        }"
        @partner-ad-click="handlePartnerAdClick"
      /> -->
      <AdUnit_GAM :adInfo="adsenseAdsInfo" />
      <!-- <AdUnit_mediaNet :adSlotInfo="mediaNetAdsInfo" class="ad-style" /> -->
      <Blogs_individual_page
        v-if="truckType === 'dealer'"
        :manufacturer="truck.manufacturer"
      />
      <Popups
        v-if="shouldDisplayPopup"
        @toggle-pop-up="closeCertainPopup"
        @lead-requests="sendLeadRequests"
        :popupSwitch="popupSwitch"
      />
    </div>
    <WhenThingsGoWrong
      v-else-if="requestError"
      :requestError="true"
      :text="textForWhenThingsGoWrong.requestError"
      :needButton="true"
    />
    <WhenThingsGoWrong
      v-else-if="individualUnitNotFound"
      :text="textForWhenThingsGoWrong.individualUnitNotFound"
      :needButton="true"
    />
    <Spinner v-else />
  </div>
</template>

<script>
  import { defineAsyncComponent, computed } from 'vue'
  import Spinner from '../components/Spinner'
  import WhenThingsGoWrong from '../components/WhenThingsGoWrong'
  import Blogs_individual_page from '../components/Blogs_individual_page'
  import transformTruck from '../../../sharedHelpers/transformTruck'
  import buildRequestBody from '../../../sharedHelpers/buildRequestBody'
  import { getIndividualPageTitleAndDescription } from '../../../sharedHelpers/getDocumentTitleAndDescription'
  import httpRequest from '../../../sharedHelpers/httpRequest'
  import {
    throttling,
    debounce
  } from '../../../sharedHelpers/throttle_debounce_event'
  import sendLead from '../../../sharedService/sendLead'
  import { partnerAdLead } from '../../../sharedService/partnerAdLead'
  import { siteName } from '../config/siteSpecificConfig'
  import { API_TRUCK } from '../../../sharedConfigs/apiConfig'
  import {
    truckTypesAndRoutesMap,
    truckLeadTypes,
    textForWhenThingsGoWrong
  } from '../../../sharedConfigs/miscConfig'
  import TruckInfo from '../components/TruckInfo'
  // import Popups from '../components/Popups'
  // import AdUnit_mediaNet from '../../../sharedComponents/AdUnit_mediaNet'
  // import AdUnit_responsive_adsense from '../../../sharedComponents/AdUnit_responsive_adsense'
  import ImageBlock from '../../../sharedComponents/ImageBlock'
  // import PartnerAd from '../../../sharedComponents/PartnerAd'
  import AdUnit_GAM from '../../../sharedComponents/AdUnit_GAM'
  // import handlePartnerAdClick from '../../../sharedHelpers/handlePartnerAdClick'
  import gtag from '../../../sharedHelpers/gtag'
  import { setStatusTag } from '../../../sharedHelpers/prerenderTags'
  import {
    add as addNoIndexMetaTag,
    remove as removeNoIndexMetaTag
  } from '../../../sharedHelpers/noIndexMetaTag'
  import { GA_TRACKING_ID } from '../config/siteSpecificConfig'
  // import { sleepertraderAggregatePage_adsense } from '../config/adsConfig'
  import {
    // sleepertraderAggregatePage_mediaNet,
    sleepertrader_adsense_through_GAM
  } from '../config/adsConfig'
  import { getUnitName } from '../../../sharedHelpers/getDocumentTitleAndDescription'
  export default {
    components: {
      TruckInfo,
      Popups: defineAsyncComponent(() => import('@/components/Popups.vue')),
      ImageBlock,
      Spinner,
      WhenThingsGoWrong,
      Blogs_individual_page,
      // AdUnit_responsive_adsense,
      // AdUnit_mediaNet,
      // PartnerAd,
      AdUnit_GAM
    },
    data: () => {
      return {
        truckLeadTypes,
        popupSwitch: {
          showMsgPopup: false,
          showProfilePopup: false
        },
        vw: 0,
        resizeEvents: [],
        fromOfferBtn: false,
        truck: null,
        imgAlt: '',
        imageIndex: 0,
        imageWidth: null,
        secondValue: null,
        fifthValue: null,
        description: '',
        requestError: false,
        individualUnitNotFound: false,
        textForWhenThingsGoWrong,
        // siteName,
        adsenseAdsInfo: sleepertrader_adsense_through_GAM.individualPage,
        //control if button on popup after being clicked should display loader while request is in process
        shouldShowLoader: false,
        similarUnitsRoute: null
        // mediaNetAdsInfo: sleepertraderAggregatePage_mediaNet[0]
      }
    },
    provide() {
      return {
        shouldShowLoader: computed(() => this.shouldShowLoader),
        fromOfferBtn: computed(() => this.fromOfferBtn)
      }
    },
    computed: {
      shouldDisplayPopup: function () {
        return (
          this.popupSwitch.showProfilePopup || this.popupSwitch.showMsgPopup
        )
      },
      picIndexIndicator: function () {
        return `${this.imageIndex + 1} / ${this.truck.pics.length}`
      },
      emailed: function () {
        return this.$store.getters.getEmailedUnits[this.truckId]
      },
      headerTitle: function () {
        if (this.truck) return this.truck.title
        else if (this.requestError) return 'Request Error'
        else if (this.individualUnitNotFound) return 'Unit Unavailable'
        else return 'Loading...'
      }
    },
    props: {
      truckType: String,
      truckId: String
    },
    async created() {
      try {
        this.vw = Math.max(
          document.documentElement.clientWidth || 0,
          window.innerWidth || 0
        )
        this.setResizeEvents()
        let truckTypeConfig = truckTypesAndRoutesMap[this.truckType]
        this.similarUnitsRoute = {
          path: `/trucks-${truckTypeConfig.route}`
        }
        let truckHint = this.$store.getters.getIndividualTruckHint
        if (truckHint) {
          this.truck = this.$store.getters.getIndividualCachedTruck({
            key: truckHint,
            truckId: this.truckId
          })
          this.$store.commit('setIndividualTruckHint', null)
        } else await this.getAndTransformTruck()
        if (!this.individualUnitNotFound) {
          if (this.truckType !== 'auctioneer') {
            this.secondValue = this.truck.defaultPayment
            // this.secondValue = ''
            if (this.truckType === 'dealer') this.fifthValue = this.truck.price
            else this.fifthValue = this.truck.downPayment
            // else this.fifthValue = ''
          } else {
            this.secondValue = this.truck.dealername
            this.fifthValue = this.truck.startdate
          }
          if (this.truck.description)
            this.description = this.truck.description.replace(/\uFFFD/g, '')
          if (this.truck.pics.length) {
            this.imgAlt = `${this.truck.year} ${
              this.truck.manufacturer
            } ${getUnitName(this.truck.category, '', siteName, false)} ${
              truckTypeConfig.salesType
            } In ${this.truck.state}`
            this.$nextTick(function () {
              this.imageWidth =
                this.$refs.imageSlidesBlock.scrollWidth / this.truck.pics.length
              this.$refs.imageSlidesBlock.addEventListener(
                'scroll',
                debounce(() => {
                  this.imageIndex = Math.round(
                    this.$refs.imageSlidesBlock.scrollLeft / this.imageWidth
                  )
                }, 250)
              )
            })
          }
          this.similarUnitsRoute.query = {
            category: this.truck.category,
            manufacturer: this.truck.manufacturer
          }
          gtag('config', GA_TRACKING_ID, {
            page_path: this.$route.fullPath
          })
          this.sendLeadRequests([
            {
              functionName: 'sendTruckLead',
              lead: { leadType: truckLeadTypes.view }
            }
          ])
        }
      } catch (error) {
        this.requestError = true
      } finally {
        this.seoSetting()
      }
    },
    beforeUnmount() {
      removeNoIndexMetaTag()
      for (let i = 0; i < this.resizeEvents.length; i++)
        window.removeEventListener('resize', this.resizeEvents[i])
    },
    methods: {
      setResizeEvents() {
        let thisRef = this
        this.resizeEvents.push(
          throttling(function () {
            thisRef.vw = Math.max(
              document.documentElement.clientWidth || 0,
              window.innerWidth || 0
            )
          }, 250)
        )
        for (let i = 0; i < this.resizeEvents.length; i++)
          window.addEventListener('resize', this.resizeEvents[i])
      },
      seoSetting() {
        if (this.truck) {
          setStatusTag(200)
          removeNoIndexMetaTag()
        } else {
          addNoIndexMetaTag()
          setStatusTag(404)
        }
        this.setCanonicalURL()
        this.setDocumentTitleAndDescription()
      },
      setCanonicalURL() {
        document
          .querySelector('link[rel="canonical"]')
          .setAttribute('href', `https://${siteName}.com${this.$route.path}`)
      },
      setDocumentTitleAndDescription() {
        let documentTitleAndDescription
        if (this.truck) {
          documentTitleAndDescription = getIndividualPageTitleAndDescription(
            siteName,
            this.truckType,
            this.truck,
            false
          )
        } else
          documentTitleAndDescription = {
            title: this.textForWhenThingsGoWrong.individualUnitNotFound,
            description: this.textForWhenThingsGoWrong.individualUnitNotFound
          }
        document.title = documentTitleAndDescription.title
        document
          .querySelector('meta[name="description"]')
          .setAttribute('content', documentTitleAndDescription.description)
      },
      async getAndTransformTruck() {
        let response = (
          await httpRequest(
            {
              method: 'post',
              url: `${API_TRUCK.url}${API_TRUCK.endpoints.getTruck.endpoint}`,
              data: buildRequestBody({
                truckType: this.truckType,
                truckId: this.truckId
              })
            },
            siteName
          )
        ).data
        if (response.status) {
          // throw new Error()
          this.truck = transformTruck(
            response[API_TRUCK.endpoints.getTruck.responseKeyName],
            this.truckType
          )
        } else this.individualUnitNotFound = true
      },
      closeCertainPopup({ targetKey, value }) {
        this.popupSwitch[targetKey] = value
      },
      displayCertainPopup(fromOfferBtn = false) {
        this.fromOfferBtn = fromOfferBtn
        if (this.$store.getters.profileValid)
          this.popupSwitch.showMsgPopup = true
        else this.popupSwitch.showProfilePopup = true
      },
      slideImage(step) {
        let newImageIndex = this.imageIndex + step
        if (newImageIndex < 0)
          this.$refs.imageSlidesBlock.scrollLeft =
            (this.truck.pics.length - 1) * this.imageWidth
        else if (newImageIndex >= this.truck.pics.length)
          this.$refs.imageSlidesBlock.scrollLeft = 0
        else this.$refs.imageSlidesBlock.scrollLeft += step * this.imageWidth
      },
      async sendPartnerAdLead({ leadTypes }) {
        let { firstName, lastName, email, phoneNumber } =
          this.$store.getters.getProfile
        await partnerAdLead(
          this,
          {
            firstName,
            lastName,
            email,
            phoneNumber,
            leadTypes
          },
          siteName
        )
      },
      async sendTruckLead({ leadType, message, shouldSendExtraLeads }) {
        let targetTruck = {
          truckId: this.truckId,
          dealerId: this.truck.dealerid
        }
        await sendLead(this, {
          leadType,
          targetTruck,
          message,
          siteName,
          shouldSendExtraLeads
        })
      },
      //all lead requests will go through this function,
      // if more than one lead in a single event, each should be in the format of { functionName, lead }
      async sendLeadRequests(leadsDetail) {
        this.shouldShowLoader = true
        for (let { functionName, lead } of leadsDetail) {
          await this[functionName](lead)
        }
        this.shouldShowLoader = false
      }
      // handlePartnerAdClick(partnerAdConfig) {
      //   handlePartnerAdClick(this, {
      //     ...partnerAdConfig,
      //     adFormat: 'display_on_individual'
      //   })
      // }
    }
  }
</script>

<style lang="scss">
  .truck-view-container {
    @extend .container-small;
    margin-bottom: 78px;
    background-color: $white;
    .pop-up {
      margin-left: -12px;
    }
  }
  .truck-view-content {
    display: flex;
  }
  .truck-info,
  .gallery-container {
    width: 50%;
  }
  .gallery-container {
    margin-right: 24px;
  }
  .gallery {
    border-radius: 0.5rem;
    overflow-x: scroll;
    white-space: nowrap;
    scroll-snap-type: x mandatory;
    @include hideScrollbar;
  }
  .slide-buttons {
    position: relative;
    @include displayGrid(15% 70% 15%);
    text-align: center;
    margin: 6px 6px 0 6px;
    @include font(16px);
    span {
      padding-top: 8px;
      color: $blue;
    }
    button {
      @include buttonColor($white, $blue);
      padding: 16px 0;
    }
    .pre-slide-btn {
      @include backgroundAndPosition($icon-white-chevron-left, center 4px);
    }
    .next-slide-btn {
      @include backgroundAndPosition($icon-white-chevron-right, center 4px);
    }
  }

  .truck-info {
    .truck-details {
      @include font(16px);
      white-space: normal;
      color: $gray-5;
      text-align: left;
      & > * {
        line-height: 30px;
      }
      .truck-title,
      .truck-price {
        font-size: 22px;
      }
    }
  }
  .stock-number {
    @include font(18px);
    color: $gray-5;
    padding: 0 6px 6px 6px;
    span {
      color: $blue;
    }
  }

  .btn-basic {
    @extend .btn-common-feature;
    color: white;
    width: 100%;
    margin: 3px auto;
    @include centerBackground(right 80% bottom 50%);
  }
  .view-units-btns {
    display: flex;
    margin-top: 6px;
    .view-dealer-inventory,
    .view-similar-units {
      width: 50%;
      background-color: $blue;
      margin: 2px;
      text-align: center;
      border-radius: 0.5rem;
    }
  }

  .call-dealer-btn {
    display: block;
    text-align: center;
    border-radius: 0.5rem;
    background-color: $green;
    background-image: url($icon-white-call);
  }
  .email-dealer-btn {
    background-color: $yellow;
    background-image: url($icon-white-email);
  }
  .offer-btn {
    background-color: $green;
    background-image: url($icon-white-dollar-sign);
  }
  .emailed-dealer-btn {
    color: $gray-4;
    background-color: $yellow-mid;
    background-image: url($icon-gray-email-read);
  }

  .truck-description-table {
    width: 100%;
    @include font(14px);
    margin-top: 6px;
    line-height: 24px;
    color: $gray-5;
    text-align: left;
    border-collapse: collapse;
    th,
    td {
      padding: 6px 12px;
      border-spacing: 0;
    }
    tr {
      @include table-color-and-round-corner;
    }
  }
  .description-data {
    max-height: 200px;
    overflow: auto;
    word-break: break-word;
    white-space: pre-line;
    @include hideScrollbar;
  }
  @media screen and (max-width: 700px) {
    .truck-view-content {
      flex-direction: column;
      .truck-info,
      .gallery-container {
        width: 100%;
      }
    }
    .call-dealer-btn,
    .email-dealer-btn,
    .offer-btn,
    .emailed-dealer-btn {
      @include centerBackground(right 70% bottom 50%);
    }
  }
  @media screen and (max-width: 500px) {
    .call-dealer-btn,
    .email-dealer-btn,
    .offer-btn,
    .emailed-dealer-btn {
      padding: 6px 0;
      @include centerBackground(right 85% bottom 50%);
    }
    .view-dealer-inventory,
    .view-similar-units {
      font-size: 12px;
      padding: 6px;
    }
    .truck-info {
      font-size: 14px;
      .truck-details {
        & > * {
          line-height: 25px;
        }
        .truck-title,
        .truck-price {
          font-size: 20px;
        }
      }
    }
  }
</style>
